import React, { useState, useEffect } from "react";
import { db } from "../../firebase";
import { collection, getDocs } from "firebase/firestore";
import AdminSidebar from "../../components/admin/AdminSidebar";
import AdminHeader from "../../components/admin/AdminHeader";
import "../../styles/admin/AdminDashboard.css";
import { FaUsers, FaBriefcase, FaDollarSign, FaChartLine } from "react-icons/fa";

function AdminDashboard() {
  const [stats, setStats] = useState({
    totalUsers: 0,
    totalProjects: 0,
    activeProjects: 0,
    totalEarnings: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        // Fetch users
        const usersSnapshot = await getDocs(collection(db, "users"));
        let totalEarnings = 0;
        usersSnapshot.forEach((doc) => {
          const userData = doc.data();
          totalEarnings += userData.totalEarnings || 0;
        });

        // Fetch projects
        const projectsSnapshot = await getDocs(collection(db, "projects"));
        let activeCount = 0;
        projectsSnapshot.forEach((doc) => {
          const projectData = doc.data();
          if (projectData.status !== "Completed") {
            activeCount++;
          }
        });

        setStats({
          totalUsers: usersSnapshot.size,
          totalProjects: projectsSnapshot.size,
          activeProjects: activeCount,
          totalEarnings: totalEarnings
        });
      } catch (error) {
        console.error("Error fetching stats:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  return (
    <div className="admin-layout">
      <AdminSidebar />

      <div className="admin-content">
        <AdminHeader title="Admin Dashboard" />
        <p className="admin-subtitle" style={{ padding: '0 2rem' }}>Overview of platform statistics</p>

        {loading ? (
          <p style={{ padding: '0 2rem' }}>Loading statistics...</p>
        ) : (
          <div className="admin-grid" style={{ padding: '0 2rem' }}>
            <div className="admin-card">
              <div className="card-icon" style={{ background: "#3b82f6" }}>
                <FaUsers />
              </div>
              <div className="card-content">
                <h3>Total Users</h3>
                <p className="card-value">{stats.totalUsers}</p>
                <span className="card-label">Registered freelancers</span>
              </div>
            </div>

            <div className="admin-card">
              <div className="card-icon" style={{ background: "#10b981" }}>
                <FaBriefcase />
              </div>
              <div className="card-content">
                <h3>Total Projects</h3>
                <p className="card-value">{stats.totalProjects}</p>
                <span className="card-label">{stats.activeProjects} active</span>
              </div>
            </div>

            <div className="admin-card">
              <div className="card-icon" style={{ background: "#f59e0b" }}>
                <FaChartLine />
              </div>
              <div className="card-content">
                <h3>Active Projects</h3>
                <p className="card-value">{stats.activeProjects}</p>
                <span className="card-label">In progress</span>
              </div>
            </div>

            <div className="admin-card">
              <div className="card-icon" style={{ background: "#8b5cf6" }}>
                <FaDollarSign />
              </div>
              <div className="card-content">
                <h3>Total Earnings</h3>
                <p className="card-value">₹{stats.totalEarnings.toLocaleString()}</p>
                <span className="card-label">Platform-wide</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminDashboard;
